export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    const d = new Date(v.length <= 10 ? `${v}T00:00:00` : v);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  } catch { return v; }
};

export const STATUS_LABELS = {
  new: "New",
  in_production: "In Production",
  in_progress: "In Production",  // legacy alias
  fulfilled: "Fulfilled",
  ready: "Fulfilled",  // legacy alias
  completed: "Completed",
};

export const normalizeStatus = (s) => {
  if (s === "in_progress") return "in_production";
  if (s === "ready") return "fulfilled";
  return s || "new";
};

export const PAYMENT_LABELS = { unpaid: "Unpaid", partial: "Partial", paid: "Paid" };
